// extracted by mini-css-extract-plugin
export default {"button":"RequiredButtonSwitch_button__O5upv"};